@if (studyVariableParams?.length > 0) {
  <div class="flex flex-row align-items-start py-1">
    <div class="w-3 flex-shrink-0 align-content-center">
      <span class="fas fa-tags fa-fw my-1 py-1" aria-hidden="true"></span
        >&nbsp;Study Variables
      </div>
      <div class="flex-1 flex flex-row flex-wrap">
        @for (cvParam of studyVariableParams; track cvParam) {
          <span class="p-tag m-1 p-1 classification">
            <app-olslink [cvParam]="cvParam" [displayValue]="false"></app-olslink>&nbsp;
            <app-olslink [cvParam]="cvParam" [displayValue]="false" [linkOnly]="true"></app-olslink>
          </span>
        }
      </div>
    </div>
  }
  @if (sampleParams?.length > 0) {
    <div class="flex flex-row align-items-start py-1">
      <div class="w-3 flex-shrink-0 align-content-center">
        <span class="fas fa-tags fa-fw my-1 py-1" aria-hidden="true"></span
          >&nbsp;Sample Characteristics
        </div>
        <div class="flex-1 flex flex-row flex-wrap">
          @for (cvParam of sampleParams; track cvParam) {
            <span class="p-tag m-1 p-1 classification">
              <app-olslink [cvParam]="cvParam" [displayValue]="true"></app-olslink>&nbsp;
              <app-olslink [cvParam]="cvParam" [displayValue]="false" [linkOnly]="true"></app-olslink>
            </span>
          }
        </div>
      </div>
    }
    @if (assayParams?.length > 0) {
      <div class="flex flex-row align-items-start py-1">
        <div class="w-3 flex-shrink-0 align-content-center">
          <span class="fas fa-tags fa-fw my-1 py-1" aria-hidden="true"></span
            >&nbsp;Assay Characteristics
          </div>
          <div class="flex-1 flex flex-row flex-wrap">
            @for (cvParam of assayParams; track cvParam) {
              <span class="p-tag m-1 p-1 classification">
                <app-olslink [cvParam]="cvParam" [displayValue]="true"></app-olslink>&nbsp;
                <app-olslink [cvParam]="cvParam" [displayValue]="false" [linkOnly]="true"></app-olslink>
              </span>
            }
          </div>
        </div>
      }
      @if (instrumentParams?.length > 0) {
        <div class="flex flex-row align-items-start py-1">
          <div class="w-3 flex-shrink-0 align-content-center">
            <span class="fas fa-tags fa-fw my-1 py-1" aria-hidden="true"></span
              >&nbsp;Instrument Characteristics
            </div>
            <div class="flex-1 flex flex-row flex-wrap">
              @for (cvParam of instrumentParams; track cvParam) {
                <span class="p-tag m-1 p-1 classification">
                  <app-olslink [cvParam]="cvParam" [displayValue]="true"></app-olslink>&nbsp;
                  <app-olslink [cvParam]="cvParam" [displayValue]="false" [linkOnly]="true"></app-olslink>
                </span>
              }
            </div>
          </div>
        }
        @if (msRunParams?.length > 0) {
          <div class="flex flex-row align-items-start py-1">
            <div class="w-3 flex-shrink-0 align-content-center">
              <span class="fas fa-tags fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;MS
              Run Characteristics
            </div>
            <div class="flex-1 flex flex-row flex-wrap">
              @for (cvParam of msRunParams; track cvParam) {
                <span class="p-tag m-1 p-1 classification">
                  <app-olslink [cvParam]="cvParam" [displayValue]="true"></app-olslink>&nbsp;
                  <app-olslink [cvParam]="cvParam" [displayValue]="false" [linkOnly]="true"></app-olslink>
                </span>
              }
            </div>
          </div>
        }
        @if (unspecifiedParams?.length > 0) {
          <div class="flex flex-row align-items-start py-1">
            <div class="w-3 flex-shrink-0 align-content-center">
              <span class="fas fa-tags fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Unspecified Characteristics
            </div>
            <div class="flex-1 flex flex-row flex-wrap">
              @for (cvParam of unspecifiedParams; track cvParam) {
                <span class="p-tag m-1 p-1 classification">
                  <app-olslink [cvParam]="cvParam" [displayValue]="true"></app-olslink>&nbsp;
                  <app-olslink [cvParam]="cvParam" [displayValue]="false" [linkOnly]="true"></app-olslink>
                </span>
              }
            </div>
          </div>
        }
